import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import ThumbDown from '../../../../../../icons/ThumbDown'
import Heart from '../../../../../../icons/Instagram/Heart'

import { IPostElementProps } from '../../../../../../types/types'
import { useDispatch, useSelector } from 'react-redux'
import { getTheme } from '../../../../../../../store/common/common.selectors'
import { FacebookPostComment, NetworkType } from '@3m5/sm_publish-frontend-api'
import {
  LikeFacebookPostCommentRequest,
  UnlikeFacebookPostCommentRequest,
} from '@3m5/sm_publish-frontend-api'
import {
  likeFacebookPostCommentInitiated,
  unlikeFacebookPostCommentInitiated,
} from '../../../../../../../store/facebook/facebook.actions'
import ThumbUp from '../../../../../../icons/ThumbUp'
import EmptyHeart from '../../../../../../icons/Instagram/EmptyHeart'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body2.fontSize,
    textTransform: 'inherit',
    width: '100%',
    justifyContent: 'flex-start',
    padding: '3px 0 0 0',
    marginLeft: '12px',
  },
  icon: {
    verticalAlign: 'top',
    fill: theme.palette.info.main,
  },
}))

const CommentLike: React.FC<IPostElementProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const dispatch = useDispatch()

  const dispatchLikePostComment = useCallback((params: LikeFacebookPostCommentRequest) => dispatch(likeFacebookPostCommentInitiated(params)), [dispatch])
  const dispatchUnlikePostComment = useCallback((params: UnlikeFacebookPostCommentRequest) => dispatch(unlikeFacebookPostCommentInitiated(params)), [dispatch])

  const theme: Theme = useSelector(getTheme)

  const comment: FacebookPostComment = props.value
  const mainColor = theme.palette.primary.main

  const [like, setLike] = React.useState<boolean>(comment.userLikes)

  const likeComment = () => {
    if (comment.networkCommentId && props.networkPageId) {
      setLike(true)
      const params: LikeFacebookPostCommentRequest = {
        networkPageId: props.networkPageId,
        networkPostId: props.post.networkPostId,
        networkCommentId: comment.networkCommentId,
      }
      dispatchLikePostComment(params)
    }
  }

  const unlikeComment = () => {
    if (comment.networkCommentId && props.networkPageId) {
      setLike(false)
      const params: UnlikeFacebookPostCommentRequest = {
        networkPageId: props.networkPageId,
        networkPostId: props.post.networkPostId,
        networkCommentId: comment.networkCommentId,
      }
      dispatchUnlikePostComment(params)
    }
  }

  const buttonTextLike =
    <>
      <span style={{ paddingRight: '5px' }}>
        {props.networkType === NetworkType.Facebook
          ? (<ThumbUp className={classes.icon} color={mainColor} width='18px' />)
          : (<EmptyHeart className={classes.icon} color={mainColor} />)}
      </span>
      {t('postCommon:like')}
    </>
  const buttonTextUnLike =
    <>
      <span style={{ paddingRight: '5px' }}>
        {props.networkType === NetworkType.Facebook
          ? (<ThumbDown className={classes.icon} color={mainColor} width='18px' />)
          : (<Heart className={classes.icon} color={mainColor} />)}
      </span>
      {t('postCommon:unlike')}
    </>
  return (
    <>
      <ButtonComponent
        text={like ? buttonTextUnLike : buttonTextLike} color='info' className={classes.root} variant='text' onClick={() => {
          like ? unlikeComment() : likeComment()
        }}
      />
    </>
  )
}

export default CommentLike
